import { TextField } from "@mui/material";
import styled from "styled-components";

export const StyledInput = styled(TextField)`
  margin-top: 8px !important;
  border-color: #fff !important;

  > div {
    border-radius: 16px !important;
    /* box-shadow: 2px 2px 1px 0px rgba(0, 0, 0, 0.203) !important; */
    box-shadow: -1px -1px 4px 0px rgb(255, 255, 255),
      2px 2px 6px 0px rgba(0, 0, 0, 0.2) !important;

    background-color: #fff !important;

    border-color: #fff !important;
  }
  > div input {
    border-color: #fff !important;

    padding: 6px 12px !important;
  }
`;
